import { UiSchema } from "@rjsf/utils";

export const achUiSchema: UiSchema = {
  "ui:submitButtonOptions": {
    submitText: "Submit",
    norender: true,
  },
  instructions: {
    "ui:field": "instructionsField",
  },
  questionText: {
    "ui:field": "questionTextField",
  },
  requiredFieldNote: {
    "ui:field": "requiredFieldNote",
  },
  achType: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
  },
  optionNote: {
    "ui:description":
      "**NOTE: If you are a group submitting ACH Debit information for premium payments, PLEASE SELECT OPTION 1. If you are an agent/broker setting up commission payments to your company, PLEASE SELECT OPTION 2.",
  },
  typeOfTransaction: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
  },
  monthlyOrOneTimePull: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
  },
  submittedOneTimePayment: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
  },
  usePreviousBankInfo: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
  },
  employerBrokerMember: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
  },
  nameOfCompany: {
    "ui:options": {
      xs: 6,
    },
  },
  groupNumber: {
    "ui:widget": "NumericWidget",
    "ui:options": {
      xs: 6,
    },
  },
  location: {},
  nameOfBrokerOnRecord: {
    "ui:options": {
      xs: 6,
    },
  },
  nameOfCobraMember: {},
  brokerName: {},
  commissionsPayableTo: {
    "ui:widget": "radio",
    "ui:options": {
      inline: false,
    },
  },
  brokerGroupNumber: {},
  addressTitle: {
    "ui:field": "sectionTitleField",
  },
  addressLine1: {},
  addressLine2: {},
  city: {},
  state: {},
  zipCode: { "ui:widget": "NumericWidget" },
  taxId: { "ui:widget": "TaxIdWidget" },
  email: {
    "ui:placeholder": "your.email@example.com",
  },
  w9FileUpload: {
    "ui:options": {
      accept: ".pdf,.jpg,.jpeg,.png",
      style: {
        maxWidth: "100%",
        width: "100%",
      },
    },
  },
  financialInstitutionName: {},
  fiAddressTitle: {
    "ui:field": "sectionTitleField",
  },
  fiAddressLine1: {},
  fiAddressLine2: {},
  fiCity: {},
  fiState: {},
  fiZipCode: { "ui:widget": "NumericWidget" },
  accountType: {
    "ui:widget": "radio",
    "ui:options": {
      inline: true,
    },
  },
  routingNumber: { "ui:widget": "NumericWidget" },
  accountNumber: { "ui:widget": "NumericWidget" },
  oneTimeAmount: { "ui:widget": "hidden" },
  authorizationText: {
    "ui:field": "authorizationTextField",
  },
  bankingDocumentUpload: {
    "ui:options": {
      accept: ".pdf,.jpg,.jpeg,.png",
      style: {
        maxWidth: "100%",
        width: "100%",
      },
    },
  },
  date: {},
  typedSignature: {},
};
